
<!-- 自定义的loading  有进度和图片-->
<template>
  <div 
  v-loading="true"
  :element-loading-text="text"
  element-loading-spinner="el-icon-loading"
  element-loading-background="rgba(0, 0, 0, 0.2)"
  v-if="visible" 
  class="loading-overlay">
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data() {
    return {
      visible: false,
      text: '正在处理中，请稍后',
      jindu: 0,
      intervalId: null
    }
  },
  watch: {
    visible(newval) {
   
    }
  },
  methods: {
    cardloading1(bool, text) {
      if(bool) {
        this.visible = bool;
         this.text = text;
      }else {
       
       // setTimeout(() => {
          this.visible = bool;
        // }, 500);
      }
    },

 
  },
  beforeDestroy() {
  }
}
</script>

<style scoped lang="scss">
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
}

::v-deep .el-loading-spinner i{
  color: #fff;
}
::v-deep .el-loading-spinner .el-loading-text{
  color: #fff;
}
</style>